module.exports = __webpack_public_path__ + "static/img/mifi_bg_3.9eb027e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/s1/mifi_bg_3.jpg
// module id = 681
// module chunks = 0